import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import ReactToPrint from "react-to-print";
import { motion } from "framer-motion";
import PrintTemplate from "./PrintTemplate";
import { grid } from "ldrs";
import { useStyle } from "../context/StyleContext";
import axios from "axios";

// Register the grid once
grid.register();

const PrintPage = () => {
  const componentRef = useRef();
  const triggerRef = useRef();
  const navigate = useNavigate();
  const [countdown, setCountdown] = useState(5);
  const videoRef = useRef(null);
  const styles = useStyle();
  useEffect(() => {
    if (triggerRef.current) {
      triggerRef.current.click();
    }
    const video = videoRef.current;
    video.onloadeddata = () => {
      video.play();
    };
  }, []);

  useEffect(() => {
    const timer = setInterval(() => {
      setCountdown((prevCountdown) => prevCountdown - 1);
    }, 1000);
    // Call the increment API endpoint before navigating away.
    

    const navigateTimeout = setTimeout(() => {
      clearInterval(timer);
      // navigate("/sharing-options");
      navigate("/thank-you");
    }, 22000); // Set to 10 seconds to match the countdown

    return () => {
      clearInterval(timer);
      clearTimeout(navigateTimeout);
    };
  }, [navigate]);

  let filteredPhotos;
  try {
    filteredPhotos = JSON.parse(localStorage.getItem("filteredPhotos"));
  } catch (error) {
    console.error("Error accessing filtered photos from local storage:", error);
    filteredPhotos = [];
  }
  const printTheme = localStorage.getItem("printTheme") || "light";

  return (
    <div className="relative min-h-screen flex flex-col items-center justify-center overflow-hidden">
      <ReactToPrint
        trigger={() => (
          <button ref={triggerRef} className="hidden">
            Print
          </button>
        )}
        content={() => componentRef.current}
      />
      <div style={{ display: "none" }}>
        <PrintTemplate
          ref={componentRef}
          photos={filteredPhotos?.map((photo) => photo.src) || []}
          theme={printTheme}
        />
      </div>
      <div className="h-[60vh] flex justify-center flex-col font-bold items-center text-7xl text-white">
        <div className="p-6 rounded-lg relative">
          <video
            ref={videoRef}
            className="h-[60%] mx-auto object-cover z-0"
            autoPlay
            loop
            muted
            preload="auto"
          >
            <source src={styles.printingAnimation} type="video/webm" />
          </video>
        </div>
        <div
          style={{ fontFamily: styles.fontFamily, color: styles.textColor }}
          className=" text-5xl"
        >
          PRINTING...
        </div>
      </div>
    </div>
  );
};

export default PrintPage;
